import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse, HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-scheduled-jobs-configuration',
  templateUrl: './scheduled-jobs-configuration.component.html',
  styleUrls: ['./scheduled-jobs-configuration.component.scss'],
})
export class ScheduledJobsConfigurationComponent implements OnInit {
  scheduledJobType: string;
  getInvoices: any;

  constructor(private alertService: AlertService, private http: HttpClient, private g: Globals, private api: ApiIntegration, public user: User, private route: ActivatedRoute, private router: Router) {
  }

  ngOnInit() {
  }


  scheduledJobFunction(scheduledJobType) {
    let api = "";

    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    if (scheduledJobType == 'updateAccountOwner') {
      api = 'api/updateAccountOwnerStatus';
    } else if (scheduledJobType == 'scheduleForAutoRenewWarehouse') {
      api = 'api/scheduleForAutoRenewWarehouseServices';
    } else if (scheduledJobType == 'scheduleForNotifyCustomerForWarehouse') {
      api = 'api/scheduleForNotifyCustomerForWarehouseServiceExpiry';
    } else if (scheduledJobType == 'generateMonthlyInvoiceForWarehouse') {
      api = 'api/generateMonthlyInvoiceForWarehouseServices';
    } else if (scheduledJobType == 'generateInvoice') {
      api = 'api/generateInvoiceForAccountOwner';
    } else if (scheduledJobType == 'purgeEndCustomer') {
      api = 'api/purgeEndCustomer';
    } else if (scheduledJobType == 'deleteAccountOwnerData') {
      api = 'api/deleteAccountOwnerData';
    } else if (scheduledJobType == 'shipmentTrackForOutboundOrder') {
      api = 'api/scheduleShipmentTrackForOutboundOrder';
    } else if (scheduledJobType == 'shipmentTrackForInBoundOrder') {
      api = 'api/scheduleShipmentTrackForInBoundOrder';
    } else if (scheduledJobType == 'deleteDemoAccount') {
      api = 'api/deleteDemoAccountData';
    } else if (scheduledJobType == 'sendRemindersForDemo') {
      api = 'api/sendRemindersForDemoAccount';
    } else if (scheduledJobType == 'trackOrder') {
      api = 'api/scheduleShipmentTrackForOrder';
    }

    this.http.post(environment.apiUrl + api, null,
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.alertService.success(data['message']);
        } else {
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  getChannelsInvoices() {
    this.api.generateInvoiceFromChannels(this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.getInvoices = data;
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }

  /*
   updateAccountOwnerStatus() {
      var header1 = new HttpHeaders();
      header1 = header1.append('Content-Type', 'application/json');
      header1 = header1.append('Accept', 'application/json');
      header1 = header1.append('Authorization', 'Bearer ' + this.local.get('jwt'));
      this.http.post(environment.apiUrl + 'api/updateAccountOwnerStatus',
        {headers: header1}).subscribe(data => {
         if(data['code'] == "200"){
          this.alertService.success('AccountOwner','Status Updated Successfully');
        }else{
            this.alertService.error(data['message']);
        }
  this.g.loaderDisplay = "";
        },
        (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        });
  }
   */


}
